import { Root as RootICS, WebSocketApiConfigs } from '@platform/ics-front-core';
import React from 'react';
import { Router } from 'react-router-dom';
import { apiConfigs } from './apiConfigs';
import { CampaignRequestHeaderDI, CurrentUserStoreDI, RootStoreDI } from './di';
import { env, features, history, locales, palette } from './initRootProps';
import { CampaignListCardDI } from './pages/campaigns/list/components/Card';

// todo возможно Router-обертка больше не нужна, проверить, когда появится di
export const Root = (): JSX.Element => {
    return (
        <Router history={history}>
            <RootICS
                env={env}
                features={features}
                locales={locales}
                history={history}
                palette={palette}
                apiConfigs={apiConfigs}
                WebSocketApiConfigsClass={WebSocketApiConfigs}
                use={[RootStoreDI, CurrentUserStoreDI, CampaignListCardDI, CampaignRequestHeaderDI]}
            />
        </Router>
    );
};
